<template>
    <v-dialog v-model="dialog" max-width="500" :fullscreen="testMode">
      <v-card>
          <v-card-title class="primary white--text title">
              Rule
          </v-card-title>
          <v-card-text>
              <v-layout row>

                  <v-flex v-bind:class="[testMode ? 'xs4' : 'xs12']">
                      <v-form v-model="valid">
                      <v-text-field label="Title" autofocus
                                    v-model="activeItem.title" browser-autocomplete="off"
                                    v-bind:rules="fieldRules"></v-text-field>
                      <v-text-field label="Description" autofocus v-model="activeItem.desc"></v-text-field>
                      <v-text-field label="Topic" autofocus v-model="activeItem.topic"></v-text-field>
                      <v-text-field label="Equipment Group" autofocus
                                    v-model="activeItem.equipment_group"></v-text-field>
                      <v-text-field label="Rule" autofocus v-model="activeItem.rule"></v-text-field>
                      <div v-if="usedParams&&usedParams.length>0">
                          Used parameters
                          <ul>
                              <li v-for="param in usedParams">
                                  {{param.parameter_name}} : {{param.parameter_value}}
                                  <v-icon
                                          small
                                          class="ml-2"
                                          @click="$can('update', 'Parameter') && editParam(param)"
                                  >
                                      fa-edit
                                  </v-icon>
                              </li>
                          </ul>
                          <parameter-record-dialog v-model="paramDialog" :item="editedParam" v-on:doreload="refreshpoints()"></parameter-record-dialog>
                      </div>
                      <v-radio-group v-model="activeItem.on" :mandatory="true">
                          <v-radio label="Rule Active when Chiller On" :value="true" color="green"></v-radio>
                          <v-radio label="Rule Active when Chiller Off" :value="false" color="yellow"></v-radio>
                          <v-radio label="Rule Active Anytime" :value="null"></v-radio>
                      </v-radio-group>
                      <severity-selector v-model="activeItem.severity" label="Severity"></severity-selector>
                      <v-text-field label="Relevant Variables" autofocus
                                    v-model="activeItem.relevant_variables"></v-text-field>
                      <v-textarea
                              label="Recommended Action"
                              v-model="activeItem.recommended_actions"
                              auto-grow
                      ></v-textarea>
                      <v-text-field label="Value" autofocus v-model="activeItem.value"></v-text-field>
                      <v-text-field label="Cost" v-model="activeItem.cost"></v-text-field>
                  </v-form>
                  </v-flex>

                  <v-flex xs8 v-if="testMode" class="pl-5">
                      <date-range-selector v-model="range"></date-range-selector>
                      <equipment-selector  v-model="equip" :typeFilter="activeItem.equipment_group"></equipment-selector>
                      <v-btn class="accent" @click="runTest()" >Run test</v-btn>
                      <v-progress-linear  v-show="loading" :indeterminate="true"></v-progress-linear>
                      <div v-if="showData&&!loading">
                          <vue-plotly disable-responsive v-if="data1" :data="data1" :layout="layout1" :options="{}"/>
                          <vue-plotly disable-responsive v-if="data2" :data="data2" :layout="layout2" :options="{}"/>
                          <vue-plotly disable-responsive v-if="data3" :data="data3" :layout="layout3" :options="{}"/>
                          <v-alert
                                  :value="error"
                                  type="error"
                          >
                              {{error}}
                          </v-alert>
                      </div>

                  </v-flex>
              </v-layout>
          </v-card-text>

          <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="primary" @click="addRecord(true)" :disabled="!valid||!$can('update', 'Rule')">Save</v-btn>
              <v-btn class="accent" @click="testMode=true" v-show="!testMode">Test the rule</v-btn>
              <v-btn class="accent" @click="testMode=false" v-show="testMode" >Close testing interface</v-btn>
              <v-btn @click="dialog=false">Cancel</v-btn>
          </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
  import {putRule,runRuleTest} from '../../helper'
  import SeveritySelector from "../SeveritySelector";
  import ParameterRecordDialog from "../parameter/ParameterRecordDialog";
  import DateRangeSelector from "../DateRangeSelector";
  import EquipmentSelector from "../EquipmentSelector";
  import moment from 'moment'
  import VuePlotly from "../VuePlotly";

  export default {
    props: {
      value: {type:Boolean, default: true},
      item: {type: Object, default: null},
      parameter: {type: Array, default: []}
    },
      components:{SeveritySelector,ParameterRecordDialog,DateRangeSelector,EquipmentSelector,VuePlotly},
      computed:{
        usedParams(){
            if(!this.activeItem.rule||this.activeItem.rule==''){
                return []
            } else {
                let used = [];
                for(let param of this.parameter){
                    if(this.activeItem.rule.indexOf(param.parameter_name)>-1){
                        used.push(param)
                    }
                }
                return used;
            }
        }
      },
    watch: {
      item (item) {
        this.initializeVar()
        if (item){
            if(item.severity){
                item.severity=item.severity.toLowerCase()
            }
          this.activeItem = this.item
        }
      },
      value () {
        if (this.dialog !=this.value){
          this.dialog=this.value
        }
      },
      dialog () {
        this.$emit('input', this.dialog)
      }
    },
    data () {
      return {
        dialog: false,
          equip: null,
          valid:false,
          range: {start: moment().subtract(30, "days").format('YYYY-MM-DD'), end: moment().format('YYYY-MM-DD')},
          fieldRules: [value => !!value || 'This value is required.',v => v.length < 100 || 'This value cannot be longer than 100 characters.'],
          data1:null,
          data2:null,
          data3:null,
          error:null,
          showData:false,
          layout1:{
            title:'Rule evaluation',
              yaxis: {
                  title: 'Rule'
              },
              xaxis: {
                  title: 'Time '
              }
          },
          layout2:{
              title:'Value',
              yaxis: {
                  title: 'Value'
              },
              xaxis: {
                  title: 'Time '
              }
          },
          layout3:{
              title:'Cost',
              yaxis: {
                  title: 'Cost'
              },
              xaxis: {
                  title: 'Time '
              }
          },
          testMode:false,
          paramDialog:false,
          loading:false,
          editedParam:null,
        activeItem: {
          desc: '',
            title: '',
          equipment_group: '',
          rule:  '',
          on: 0,
          value: '',
          cost: '',
            severity: 'low',
            relevant_variables: '',
            recommended_actions: '',
          rule_id: null
        } ,

      }
    },
    methods: {
        refreshpoints(){
            this.$emit('refreshpoints')
        },
        runTest(){
            let me=this;
            me.loading=true
            me.showData=false
            me.error=null
            this.data1=null
            this.data2=null
            this.data3=null
            runRuleTest({
                'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
                'rule': this.activeItem.rule,
                'on': this.activeItem.on,
                'value': this.activeItem.value,
                'cost': this.activeItem.cost,
                'topic': this.activeItem.topic,
                'equipment_name':this.equip,
                'date_range':[this.range.start,this.range.end]
            }).then(function(response){
                me.loading=false;
                if(response.error){
                    me.error=response.error
                } else {
                    me.data1 = [
                        {
                            x: response.timestamp,
                            y: response.evaluate,
                            name: 'Rule evaluation',
                            type: 'scatter',
                            mode: 'lines'
                        },
                    ]
                    me.data2 = [
                        {
                            x: response.timestamp,
                            y: response.compute_value,
                            name: 'Value',
                            type: 'scatter',
                            mode: 'lines'
                        },
                    ]
                    me.data3 = [
                        {
                            x: response.timestamp,
                            y: response.cost,
                            name: 'Cost',
                            type: 'scatter',
                            mode: 'lines'
                        },
                    ]
                }
                me.showData=true;
            })
        },
        editParam (param) {
            this.editedParam = Object.assign({}, param)
            this.paramDialog = true
        },
      initializeVar(close) {
          this.testMode=false
          this.loading=false
          this.equip=null
          this.showData=false
          this.error=null
          this.data1=null
          this.data2=null
          this.data3=null

        this.activeItem = {
          desc: '',
            title: '',
          equipment_group: '',
          rule:  '',
          on: true,
          value: '',
          cost: '',
            severity: 'low',
            topic: 'default',
            relevant_variables: '',
            recommended_actions: '',
          rule_id: null
        }
          if(close) {
              this.dialog = false;
          }
      },
      async addRecord (close) {
       await putRule(
          {
            'rule_id': this.activeItem.rule_id,
            'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
            'desc': this.activeItem.desc,
            'title': this.activeItem.title,
            'equipment_group': this.activeItem.equipment_group,
            'rule': this.activeItem.rule,
            'on': this.activeItem.on,
            'topic': this.activeItem.topic,
            'value': this.activeItem.value,
            'severity': this.activeItem.severity,
            'relevant_variables': this.activeItem.relevant_variables,
            'recommended_actions': this.activeItem.recommended_actions,
            'cost': this.activeItem.cost
          }
        )
          this.$emit('doreload')
          if(close) {
              this.dialog = false;
          }
      }
    },
    name: 'RuleRecordDialog'
  }
</script>

<style scoped>

</style>
